import { useNavigate } from '@tanstack/react-router';
import { Button } from 'components/Button';
import ModalWithdrawUnavailable from 'components/ModalWithdrawUnavailable/ModalWithdrawUnavailable.loadable';
import React from 'react';
import { Translate } from 'react-localize-redux';

export type WithdrawButtonProps = { id?: string; onClick?: () => void };

export default function WithdrawButton({ id, onClick }: WithdrawButtonProps) {
  const navigate = useNavigate();
  const [modalWithdrawUnavailableVisible, setModalWithdrawUnavailableVisible] =
    React.useState<boolean>(false);

  const handleClick = () => {
    onClick?.();
    navigate({ to: '/withdrawal' });
  };

  return (
    <>
      {modalWithdrawUnavailableVisible && (
        <ModalWithdrawUnavailable
          i18nHeading
          heading={'lbl.modal.title.withdrawUnavailable'}
          onClose={() => {
            setModalWithdrawUnavailableVisible(false);
          }}
        />
      )}
      <Button
        id={id}
        onClick={handleClick}
        minWidth={1.8}
        flex="1 1 auto"
        variant={'outline'}
      >
        <Translate id="lbl.modalrecharge.withdrawal" />
      </Button>
    </>
  );
}
